import { observer } from "mobx-react";
import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { SemanticSIZES } from "semantic-ui-react/dist/commonjs/generic";
import { COLORS } from "../../../constants";

interface ILoading {
  active: boolean;
  inverted?: boolean;
  size?: SemanticSIZES;
  above?: boolean;
  style?: any;
}

@observer
class Loading extends React.Component<ILoading> {
  public render() {
    const { above } = this.props;
    return (
      <Dimmer
        style={{
          ...styles.bg,
          ...this.props.style,
          zIndex: above ? 1000 : 900,
        }}
        inverted
        active={this.props.active}
      >
        <Loader size={this.props.size} />
      </Dimmer>
    );
  }
}
const styles = {
  bg: {
    backgroundColor: COLORS.white,
  },
};
export default Loading;
